import { render, staticRenderFns } from "./CellScore.vue?vue&type=template&id=f4cc9882&"
import script from "./CellScore.vue?vue&type=script&lang=js&"
export * from "./CellScore.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports